// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"e4318ee8","453":"7639d004"}[chunkId] + ".chunk.js";
};